import { render, staticRenderFns } from "./FeedbackManagement.vue?vue&type=template&id=765e2b4e"
import script from "./feedback-management.ts?vue&type=script&lang=ts&external"
export * from "./feedback-management.ts?vue&type=script&lang=ts&external"
import style0 from "./feedback-management.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports